/* eslint-disable */
export const deleteBotConstants = {
    FETCH_DELETE_BOT_REQUEST: 'FETCH_DELETE_BOT_REQUEST',
    FETCH_DELETE_BOT_SUCCESS: 'FETCH_DELETE_BOT_SUCCESS',
    FETCH_DELETE_BOT_FAILURE: 'FETCH_DELETE_BOT_FAILURE',
};
